module.exports = __webpack_public_path__ + "static/media/push_ups-01.f3030927.png";